<template>
  <section class="section one-view">
    <h2>Dale un vistazo</h2>
    <p class="text-last m-center">
      Hemos creado una configuración de prueba para que puedas interactuar con
      nuestra <br class="is-hidden-touch" />
      plataforma y ver lo fácil y sencillo trabajar con ContaFácil.
    </p>
    <div class="text-link-wrap">
      <img :src="`/images/fondo_${$route.meta.fondo}.png`" alt="" />
      <a href="" class="button is-rounded bg-ascend-second one-view-button"
        >Échale un vistazo a ContaFácil</a
      >
    </div>
    <div class="faq" v-show="faqShow">
      <h3>PREGUNTAS FRECUENTES</h3>
      <details
        class="question"
        v-for="question in faq"
        :key="`faq-${question.title}`"
      >
        <summary class="question__title">{{ question.title }}</summary>
        <div v-html="question.content" class="question__content"></div>
      </details>
    </div>
  </section>
</template>

<script>
export default {
  name: "OneView",
  data() {
    return {
      questions: [
        {
          question: "Pregunta Frecuente 1",
          answer:
            "ContaFácil es una herramienta eficiente y fácil de usar orientada a simplificar la forma de manejar tu negocio. Hacemos mas eficiente el proceso de venta orientando a mejorar la productividad del negocio, reduciendo costos y tiempo.",
          isOpen: false
        },
        {
          question: "Pregunta Frecuente 2",
          answer:
            "ContaFácil es una herramienta eficiente y fácil de usar orientada a simplificar la forma de manejar tu negocio. Hacemos mas eficiente el proceso de venta orientando a mejorar la productividad del negocio, reduciendo costos y tiempo.",
          isOpen: false
        },
        {
          question: "Pregunta Frecuente 3",
          answer:
            "ContaFácil es una herramienta eficiente y fácil de usar orientada a simplificar la forma de manejar tu negocio. Hacemos mas eficiente el proceso de venta orientando a mejorar la productividad del negocio, reduciendo costos y tiempo.",
          isOpen: false
        },
        {
          question: "Pregunta Frecuente 4",
          answer:
            "ContaFácil es una herramienta eficiente y fácil de usar orientada a simplificar la forma de manejar tu negocio. Hacemos mas eficiente el proceso de venta orientando a mejorar la productividad del negocio, reduciendo costos y tiempo.",
          isOpen: true
        },
        {
          question: "Pregunta Frecuente 5",
          answer:
            "ContaFácil es una herramienta eficiente y fácil de usar orientada a simplificar la forma de manejar tu negocio. Hacemos mas eficiente el proceso de venta orientando a mejorar la productividad del negocio, reduciendo costos y tiempo.",
          isOpen: false
        }
      ],
      qactive: 0,
      faqShow: true
    };
  },
  async created() {
    this.$modal.show("loader-root");
    try {
      await this.$store.dispatch("getFaq", this.$route.meta.path);
    } catch (error) {
      this.faqShow = false;
    } finally {
      this.$modal.hide("loader-root");
    }
  },
  computed: {
    faq() {
      return this.$store.getters.faqGetter;
    }
  },
  methods: {
    openQuestion($index) {
      this.questions.forEach((q, i) => {
        if ($index == i) {
          this.$set(this.questions[i], "isOpen", true);
        } else {
          this.$set(this.questions[i], "isOpen", false);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/general.scss";
.section {
  margin: 2rem auto 3rem;
  padding: 0px !important;
  // margin-bottom: 6rem;
  h2 {
    font-weight: bold;
    letter-spacing: 0.05em;
    font-size: 24px;
  }
  .text-last {
    width: 90%;
    font-size: 14px;
    letter-spacing: 0.025em;
    font-weight: 400;
    @include tablet() {
      width: 80%;
      font-size: 1.5rem;
      letter-spacing: 0.05em;
    }
    // @media (min-width: 900px) {
    //   width: 50%;
    //   font-size: 2rem;
    //   letter-spacing: 0.05em;
    // }
    @include laptop() {
      width: 90%;
      // max-width: 815px;
      font-size: 1.45rem;
    }
    @include desktop() {
      width: 100%;
      // max-width: 815px;
      font-size: 1.6rem;
    }
    @include desktop-large() {
      width: 90%;
      max-width: none;
      font-size: 2rem;
    }
  }
  p {
    font-size: 16px;
    width: 100%;
  }
  .faq {
    margin: 1rem auto;
    margin-bottom: 6rem;
    width: 100%;
    h3 {
      // font-size: 2rem;
      font-weight: normal;
      font-family: "Geometos", sans-serif;
      letter-spacing: 0.05em;
      font-size: 16px;
    }
    .question {
      width: 100%;
      font-size: 1rem;
      font-weight: 400;
      text-align: start;
      letter-spacing: 0.025em;
      margin: 0rem 0;
      padding: 1rem 0;

      &__title {
        font-weight: bold;
        margin-bottom: 0px;
        padding: 1rem 2rem;
        background-color: rgba(122, 122, 122, 0.2);
      }
      &__content {
        padding: 0 2em;
        background-color: #fff;
      }
      &[open] {
        background-color: #ffffff;
        .question__title {
          margin-bottom: 1rem;
        }
      }
      summary:focus {
        outline: none;
      }
    }
  }
  @include tablet() {
    margin: 2rem auto;
    margin-bottom: 6rem;
    padding: 3rem !important;
    h2 {
      font-weight: bold;
      letter-spacing: 0.05em;
      font-size: 2rem;
    }
    p {
      width: 60%;
      font-size: 1.5rem;
    }
    .button {
      max-width: fit-content;
    }
    .faq {
      margin: 3rem 0;
      // width: 75%;
      h3 {
        font-size: 1.5rem;
      }
      .question {
        font-size: 1.2rem;
      }
    }
  }
  @media (min-width: 1024px) {
    margin: 6rem auto;
    margin-bottom: 6rem;
    padding: 3rem !important;
    h2 {
      font-weight: bold;
      letter-spacing: 0.05em;
      font-size: 3rem;
    }
    p {
      width: 100%;
      font-size: 1.5rem;
    }
    .button {
      max-width: fit-content;
    }
    .faq {
      margin: 3rem auto;
      width: 68%;
      h3 {
        font-size: 2rem;
      }
      .question {
        font-size: 1.5rem;
      }
    }
  }
  @media (min-width: 1200px) {
    margin: 6rem auto;
    margin-bottom: 6rem;
    padding: 3rem !important;
    h2 {
      font-weight: bold;
      letter-spacing: 0.05em;
      font-size: 3.5rem;
    }
    p {
      width: 100%;
      font-size: 1.5rem;
    }
    .button {
      max-width: fit-content;
    }
    .faq {
      margin: 3rem auto;
      // width: 75%;
      h3 {
        font-size: 2.5rem;
      }
      .question {
        font-size: 1.5rem;
      }
    }
  }
  @media (min-width: 1800px) {
    margin: 6rem auto;
    margin-bottom: 6rem;
    padding: 3rem !important;
    h2 {
      font-weight: bold;
      letter-spacing: 0.05em;
      font-size: 4.5rem;
    }
    p {
      width: 100%;
      font-size: 1.2rem;
    }
    .button {
      max-width: fit-content;
    }
    .faq {
      margin: 3rem auto;
      // width: 75%;
      h3 {
        font-size: 2.8rem;
      }
      .question {
        font-size: 1.8rem;
      }
    }
  }
}
.text-link-wrap {
  // width: 100%;
  margin: 3em auto;
  // height: 200px;
  // background-image: url("../assets/images/video-placeholder.png");
  // background-repeat: no-repeat;
  // background-size: 100%;
  // background-position: center;
  // display: flex;
  // flex-flow: row nowrap;
  // justify-content: center;
  // align-items: center;
  position: relative;
  @include laptop() {
    margin: 6em auto 12em;
  }
  img {
    width: 90%;
    max-width: 900px;
    height: auto;
  }
  a {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0px !important;
  }
  // @include tablet() {
  //   height: 300px;
  //   width: 75%;
  // }
  // @media (min-width: 1024px) {
  //   height: 500px;
  //   width: 75%;
  // }
  // @media (min-width: 1200px) {
  //   height: 690px;
  //   width: 75%;
  // }
  // @media (min-width: 1024px) {
  //   height: 700px;
  //   width: 50%;
  // }
}
summary::-webkit-details-marker {
  display: none;
}

summary:after {
  float: right;
  height: 20px;
  width: 20px;
  content: "+";
  color: $primary;
}

details[open] summary:after {
  content: "-";
}
.one-view-button {
  font-size: 13px;
  padding-inline-start: 1.25em;
  padding-inline-end: 1.25em;
  @include laptop() {
    font-size: 20px;
  }
  // @include desktop() {
  //   font-size: 1.65rem;
  // }
  // @include desktop-large() {
  //   font-size: 1.8rem;
  // }
}
</style>
